<div class="flex flex-col items-center justify-center py-12 text-center">
  <!-- Font Awesome Icon -->
  <fa-icon
    [icon]="icon"
    class="text-[var(--primary)] text-6xl mb-4"
  ></fa-icon>

  <h2 class="text-lg font-semibold text-gray-800">
    {{ title }}
  </h2>

  <p class="text-sm text-gray-500 mt-1">
    {{ description }}
  </p>
</div>
